import myRequest from '@/services/myRequest';

export async function getMonitoringList(params) {
  return myRequest('get', '/notice/queryList', params);
}

export async function setConfirm(params) {
  return myRequest('post', '/notice/confirm', params);
}
